import React from "react";
import Footer from "./footer";
//npx serve -s build
import Webconnection from "../web3";
import { detectAndSetWeb3 } from "../web3";
import { getWebcall } from "../web3";

import { imlovABI } from "../imlov";
import { imlovaddress } from "../imlov";
import { useState } from "react";

import { useEffect, useLayoutEffect } from "react";

import { gsap } from "gsap";
import CSSPlugin from "gsap/CSSPlugin";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, useGSAP, CSSPlugin);

function ArtistStatement(props) {
  const C = CSSPlugin;
  const [decodedSVG, setDecodedSVG] = useState("");
  const [newDecodedSVG, setNewDecodedSVG] = useState("");
  const [web3, setWeb3] = useState(null);
  const [accounts, setAccounts] = useState(null);
  const [imlov, setImlov] = useState(null);
  var [intervalId, setIntervalId] = useState(null);
  var [intervalId2, setIntervalId2] = useState(null);

  const sendDataToMenu = () => {
    const data = true;
    // Call the callback function passed from Menu
    props.onDataFromMenu(data);
  };

  const onConnectButton = async (event) => {
    const connect = await window.ethereum.request({ method: "eth_accounts" });

    if (connect.length === 0) {
      await getWebcall();
      const web3Instance = await detectAndSetWeb3();
      setWeb3(web3Instance);
      const accountsList = await web3Instance.eth.getAccounts();
      setAccounts(accountsList);
      onMount();
    }
  };

  const onMount = async () => {

    document.title = "Imperfect Lovers - Artist Statement";
    const web3Instance = await detectAndSetWeb3();
    const accountsList = await web3Instance.eth.getAccounts();
    setAccounts(accountsList);
    setWeb3(web3Instance);

    const imlovInstance = new web3Instance.eth.Contract(imlovABI, imlovaddress);
    setImlov(imlovInstance);

    const tokenURI = await imlovInstance.methods.tokenURI(0).call();
    const tokenURIStr = tokenURI.replace("data:application/json;utf8,", "");
    const encodedSVG = JSON.parse(tokenURIStr).image.replace(
      "data:image/svg+xml;base64,",
      ""
    );
    setDecodedSVG(String(atob(encodedSVG)));
  };

  useEffect(() => {
    sendDataToMenu();
    document.title = "Imperfect Lovers by Nathaniel Stern";
    onMount();

    const fetchOnChainValue = async () => {
      try {
        const tokenURI2 = await imlov.methods.tokenURI(0).call();
        const tokenURIStr2 = tokenURI2.replace(
          "data:application/json;utf8,",
          ""
        );
        const encodedSVG2 = JSON.parse(tokenURIStr2).image.replace(
          "data:image/svg+xml;base64,",
          ""
        );
        const newDecodedSVGtemp = String(atob(encodedSVG2));

        if (newDecodedSVGtemp !== decodedSVG) {
          setNewDecodedSVG(newDecodedSVGtemp);
          setDecodedSVG(newDecodedSVGtemp);
        }
      } catch (error) {
        console.error("Error fetching on-chain value:", error);
      }
    };

    const interval = setInterval(fetchOnChainValue, 300000); // Poll every 10 minutes
    setIntervalId(interval);

    const interval2 = setInterval(() => {
      if (!decodedSVG) {
        onMount();
        clearInterval(interval2);
      }
    }, 3000);
    setIntervalId2(interval2);

    return () => {
      clearInterval(interval);
      clearInterval(interval2);
    };
  }, [decodedSVG]);

  
  

  //do the push thing here and then use the tostring?

  return (
    <div>
      <Webconnection />

      <header
          className="w3-display-container w3-content"
          style={{ maxWidth: "100%", minWidth: "500px", marginTop: "50px" }}
          id="home"
        >
          <a href="/">
            <img
              className="w3-image"
              src="./images/imperfect-lovers.png"
              alt="cropped Imperfect Lovers"
            />
          </a>
        </header>


      <div
        className="w3-right"
        style={{ width: "230px", marginRight: "5px", marginTop: "-5px" }}
      >
        {accounts != 0 && (
          <button
            type="button"
            disabled
            className="connect
      w3-button w3-light-grey w3-section"
          >
            connected: {accounts}
          </button>
        )}

        {accounts == 0 && (
          <button
            className="connect
      w3-button w3-light-grey w3-section"
            onClick={onConnectButton}
          >
            connect wallet
          </button>
        )}
      </div>

 

      <div
        className="w3-content"
      >
        <div className="w3-padding-32" id="about">
          <div className="w3-padding-large">
            
          <h1>Artist Statement<br /> </h1>
         
            <p>
              <i>Imperfect Lovers</i> performs two coded, on-chain Lovers, each
              giving the other "everything they have," until there is literally
              "nothing left to give." Even then, they continue to attempt
              trans-actions to and for one another, failing unless and until
              they are somehow replenished. Money is always and only a metaphor,
              and the truest of gifts can only be given when there is no-thing
              left to give. Here, the Blockchain is leveraged to show intimacy
              and care, time and mortality, imperfection and romance, despite
              (and not because of) all that glitters and shines.
            </p>

            <p>It is a piece exploring love, but also codependence, mental health, and addiction – and finding balance inside and outside of relationships.</p>

            <div
              className="w3-display-container w3-light-grey"
              style={{ width: "100%" }}
            >
              <a href="/imperfect-lovers-live" target="blank">
                <div
                  dangerouslySetInnerHTML={{ __html: decodedSVG }}
                  alt="Imperfect Lovers SVG"
                />
              </a>

              <span className="w3-tag w3-light-grey w3-small w3-left-align w3-hide-small">
                The two, live, fully on-chain Lovers.{" "}
                <a
                  href="https://opensea.io/collection/imperfect-lovers/overview"
                  target="_blank"
                >
                  View on OpenSea
                </a>
              </span>
            </div>



            <p>
              Once per day, the <i>Imperfect Lovers</i> each allocate a portion
              of themselves to the other, always losing a bit of their balance
              in the process. External viewers experience the Lovers through
              browser-based lenses, in any number of ways. The preferred
              installation &ndash; in a museum or gallery &ndash; has us walking
              between two body-sized and facing LCD screens or projections in a
              low-light, intimate setting. We see them as simple five-armed
              clocks, where each “body” is a timepiece subtly changing in size,
              beating/ticking backward and forward, breathing in and up, out and
              down, all based on how much is “left in the tank” of each wallet
              (the minute hands), and what they most recently gave and received
              (the hour hands), while seconds tick by in real time. These
              dynamic yet subtle (and fully on-chain) animations can also be
              viewed or exhibited at home or elsewhere &ndash; in individual
              browsers that are side by side, together in one interface, across
              facing smartphones, as building-sized projections, or wherever we
              want their imperfect love <i>felt</i>.
            </p>

            <p>
              The <i>Imperfect Lovers</i> live as unique Smart Contracts on the
              Ethereum Blockchain, with an initial sum of money donated by the
              artist. Once inaugurated, each is promised to gift the other
              between 25% and 78% of their account &ndash; since relationships
              are never fully equal &ndash; up to once per day. And with every
              transfer, a little more is depleted from their overall balance
              because of the required “gas” fees. Eventually, neither will be
              able to afford any transfer; but their <i>promised giving</i> will
              carry on for as long as the Blockchain exists and functions, every
              participant-activated success or failure exhausting them further
              still. Even when “running on empty,” they continue to{" "}
              <i>promise</i> and <i>try</i>: “I would if I could; I will when I
              can.”
            </p>

            <p>
              Participants can engage with this ongoing performance in multiple
              ways. First and foremost, they must trigger the intra-action.
              Although the Lovers automatically allocate some of themselves (as
              Eth) to each other, because of Smart Contract constraints, the
              transfer <i>itself</i> has to be prompted by an external wallet.
              At or after 12pm CST (1pm during daylight savings) on any given
              day, one and only one person can pay gas fees to enact that
              transfer, and they will receive a unique NFT: a <i>Portrait</i> of
              the Lovers at that precise moment. This snapshot is also fondly 
              referred to as a Daily Display (with an implicit "of affection" afterwards...). If available, participants will also be
              partially reimbursed for what they paid in gas &ndash; up to .01
              Eth, dependent on the Lovers&apos; balances and current block fees
              &ndash; consequently depleting the Lovers with every gifting. This
              decelerating reciprocity of care will carry on until each Lover is
              left with only 1 wei, or 10
              <sup className="w3-small">-18</sup> Eth, after which point they
              still <i>attempt</i> to give, but fail.
            </p>

            <img
              src="images/blue-portrait.png"
              alt="Imperfect Lovers blue portrait"
              width="100%"
            />
            <div
              className="w3-display-container w3-light-grey"
              style={{ width: "100%" }}
            >
              <span className="w3-tag w3-light-grey w3-small w3-left-align w3-hide-small">
                Sample Blockchain-generated daily Portrait of the Lovers.
                Limited to only one per day.{" "}
                <a
                  href="https://opensea.io/collection/imperfect-lovers/overview"
                  target="_blank"
                >
                  View on OpenSea
                </a>
              </span>
            </div>

            <p>
              Participants might also <a href="./participate">donate</a> to the
              main “co_operator” contract or either Lover (and thus to both),
              whose wallet addresses are public, thus filling their cups and/or
              making them active again. If they donate .125 Eth or more, they
              also have the option of leaving their name and/or a message on its
              public <a href="./participate">“Donor Wall,”</a> which lives
              permanently on-chain. Any donations will immediately be seen via
              the <i>Imperfect Lovers</i> data feed API, and become part of the
              Lovers&apos; image-based balancing with their next trans-action.
            </p>

            <p>
              Anyone can also view and/or exhibit the work, proposing
              traditional or experimental curation for the project IRL. And
              &ndash; since the <i>actual</i> work is the Smart Contract(s)
              &ndash; they can design their own interfaces/bodies for the
              Lovers, using the simple API / data feeds that I have made
              publicly available.
            </p>

            <p>
              The title <i>Imperfect Lovers</i>, and its use of clocks, are a
              reference to Felix Gonzalez Torres&apos; (FGT&apos;s) similarly
              named piece, <i>Untitled (Perfect Lovers)</i>. FGT produced his
              two battery operated clocks, slowly falling out of sync and dying,
              for his partner, Ross. It was both a romantic gesture and a direct
              response to the AIDS crisis, the lack of funding and care going to
              research HIV and support those with it, and the extreme violence
              against LGBTQ communities that continues to take on many forms to
              this day. <i>Imperfect Lovers</i> cites the romanticism in
              FGT&apos;s original, and also continues to question “care” during
              late stage capitalism, most specifically the post-pandemic mental
              health crisis. <i>Care takes time</i>, yet we are in a
              socioeconomic culture that values speed above all else. How might
              we find and give time and care in this space? Where can love and
              health, action and balance, thrive now?
            </p>

            <p>
              <i>Imperfect Lovers</i> is also a redundant proclamation: all
              lovers are imperfect. And how love itself might be expressed and
              experienced is also far from flawless. While beneath the surface
              and unseen (in our contracts and promises, hearts and intentions,
              and more) might be a constant attempt at giving and gifting, how
              we articulate and feel loving and being loved is often
              misunderstood, and changes over time and relationships. For this
              reason, curators, collectors, I, and others might not only view
              the <i>Imperfect Lovers</i> contracts via my clockwork, web-based
              software, but update, make, or commission new and different ways
              of exploring and experiencing them &ndash; new inter-faces &ndash;
              per above.
            </p>

            <img
              src="images/FGT-Perfect-Lovers.png"
              alt="Untitled (Perfect Lovers)"
              width="100%"
            />
            <div
              className="w3-display-container w3-light-grey"
              style={{ width: "100%" }}
            >
              <span className="w3-tag w3-small w3-light-grey w3-left-align w3-hide-small">
                FGT&apos;s original <i>Untitled (Perfect Lovers)</i>
              </span>
            </div>

            <p>
              Alongside its potent explorations of time and gifting, one
              question <i>Imperfect Lovers</i> asks is: Who funds love? However
              we use it, the Blockchain was built on capitalist, libertarian
              principles. Perhaps curators or collectors might provide Eth for a
              specific exhibition; or romantics &ndash; like me &ndash; might
              donate as a symbolic gift, leaving poetry or messages on-chain
              along with that gifting. But at its core, the artwork&apos;s
              potency is always explicitly outside its funding. Having Nothing =
              Given/Giving Everything.
            </p>

            <p>
              The takeaway NFT is also an FGT reference &ndash; to{" "}
              <i>Untitled (Portrait of Ross in LA)</i>, a finite/forever gift of
              life and love re-presented as a pile of candy. And the palettes of
              the Portraits are inspired by the most common colors in On
              Kawara&apos;s <i>Today</i> series.
            </p>

            <p>
              With <i>Imperfect Lovers</i>, as in life, the <i>potential</i>{" "}
              gift means more than the <i>reality</i>. It&apos;s easy &ndash; or
              at least <i>easier</i> &ndash; to give when we have abundance. But
              to give beyond our own capacity is an impossible yet beautiful
              promise: that of forever. Forever can <i>only</i> exist in
              potential. Forever can only be real, if I promise to <i>give</i>,
              if I attempt to share, even when I <i>can&apos;t</i>. The
              impossible promise of forever is, in some ways, the only promise
              worth making. It&apos;s that combination of promise beyond failure
              that is precisely what makes love so precious. Once initiated,
              these <i>Imperfect Lovers</i> will always trans-act, together and
              apart, successfully or not.
            </p>

            <p>&ndash; &ndash; &ndash;</p>
        
           <b> Watch and listen to Nathaniel Stern talk through <i>Imperfect Lovers</i> (4 min video)</b>
              <br /> <br />
              <iframe
                style={{ aspectRatio: "16 / 9", width: "100%", height: "auto" }}
                src="https://www.youtube.com/embed/_tPZ4QhxBJo?si=OQHCXCSjWS5cRzIQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>

<p>&ndash; &ndash; &ndash;</p>

            <p>
              <i>Imperfect Lovers</i> is funded in part by the{" "}
              <a href="https://www.refractionfestival.com/">Refraction</a>{" "}
              Community Arts Fund (partial minting costs and seed money for the
              Lovers) and a Dean&apos;s award from Peck School of the Arts,
              University of Wisconsin-Milwaukee (which paid for some technical
              consulting/support from{" "}
              <a href="https://steviep.xyz/">Steve Pikelny</a>).{" "}
              <a href="https://kingduane.com/">Duane King</a> assisted with the
              SVG clock design, and{" "}
              <a href="https://linktr.ee/haiverart">Haiver</a> helped develop
              the "scrollytelling" storyboard.
            </p>

       
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default ArtistStatement;
